import React from 'react';
import { Box, Typography } from '@mui/material';
import { MdLink } from 'react-icons/md';
import { CardActions, FONT, PositionBadge, StatusPill, cardSx } from './contentShared';

const BannerCard = ({ banner, onEdit, onDelete }) => {
  const type = banner.type ? banner.type.charAt(0).toUpperCase() + banner.type.slice(1) : 'Banner';
  // Show what the banner opens, never the raw database id.
  const target = banner.type === 'external'
    ? banner.externalUrl
    : banner.linkName || (banner.link ? `Linked ${banner.type || 'item'} (not found)` : '');
  return (
    <Box sx={cardSx}>
      <Box onClick={() => onEdit && onEdit(banner)} sx={{ cursor: 'pointer', position: 'relative', aspectRatio: '16 / 7', background: '#f1f5f9' }}>
        <img src={banner.image} alt={type} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
        <Box sx={{ position: 'absolute', top: 10, left: 10 }}><PositionBadge position={banner.position} /></Box>
        <Box sx={{ position: 'absolute', top: 10, right: 10 }}><StatusPill status={banner.status} /></Box>
      </Box>
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
        <Typography sx={{ fontFamily: FONT, fontWeight: 800, fontSize: 14.5, color: '#0f172a' }}>{type} banner</Typography>
        {target ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#64748b', minWidth: 0 }}>
            <MdLink size={16} style={{ flexShrink: 0 }} />
            <Typography sx={{ fontFamily: FONT, fontSize: 11.5, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={target}>
              {target}
            </Typography>
          </Box>
        ) : (
          <Typography sx={{ fontFamily: FONT, fontSize: 11.5, color: '#94a3b8' }}>No link set</Typography>
        )}
        <Box sx={{ mt: 'auto', pt: 1, display: 'flex', justifyContent: 'flex-end' }}>
          <CardActions onEdit={() => onEdit && onEdit(banner)} onDelete={() => onDelete && onDelete(banner)} />
        </Box>
      </Box>
    </Box>
  );
};

export default BannerCard;
